const baseURl = process.env.REACT_APP_URL === '' ? process.env.REACT_APP_URL : "https://trackerr-app.herokuapp.com/graphql";

export { baseURl }